import { Message } from '@arco-design/web-vue';
import { poolClueService, leadsService } from '@/api/';
import { layoutService } from '@/api/';
import { useI18n } from 'vue-i18n';
export default function useOperation() {
  const { t } = useI18n();

  // 领取线索池
  const collection = (params) => {
    return new Promise((resolve) => {
      async function check() {
        try {
          const res = await poolClueService.poolTake(params);
          if (!res.error) {
            Message.success(t('领取成功'));
            resolve(true);
          } else {
            resolve(false);
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      check();
    });
  };
  // 作废线索池
  const scrapped = (params) => {
    return new Promise((resolve) => {
      async function abandon() {
        try {
          const res = await leadsService.clueDelete(params);
          if (!res.error) {
            Message.success(t('操作成功'));
            resolve(true);
          } else {
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      }
      abandon();
    });
  };
  // 是否是线索池管理员
  const isPoolManager = async (params) => {
    return new Promise((resolve) => {
      const checkManager = async () => {
        try {
          const res = await poolClueService.isManager(params);
          if (!res.error) {
            resolve(res.result);
          } else {
            Message.error(res.error?.msg || t('操作失败'));
          }
        } catch (e) {
          console.log(e);
        }
      };
      checkManager();
    });
  };
  //全部导出
  const listDownload = async (params) => {
    try {
      const res = await layoutService.listDownload(params);
      if (!res.error) {
        Message.success({
          content: t('数据导出中') + '，' + t('tips.exportFileAlert'),
          duration: 3000
        });
      } else {
        Message.error(res.error?.msg || t('导出出错'));
      }
    } catch (e) {
      Message.error(e.message || e.statusText || t('导出出错'));
    }
  };
  return {
    collection,
    scrapped,
    isPoolManager,
    listDownload
  };
}
